
import React from "react";
import { Helmet } from "react-helmet";
import Index from "../../components/Cities/index";
import { graphql } from "gatsby";

export default function CityPage({ data }) {
  const cityData = data?.storyblokEntry ? JSON.parse(data.storyblokEntry.content).Meta : {};
  const title = cityData?.title;
  const description = cityData?.description;

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
      <Index
        city="Lee's Summit"
        state="MO"
        url="auto-insurance-lee-s-summit-mo"
      />
    </>
  );
}

export const query = graphql`
  query {
    storyblokEntry(full_slug: { eq: "insureonline/city-pages/states/missouri/auto-insurance-lee-s-summit-mo/meta-data" }) {
      name
      content
    }
  }
`;
        